<div class="reservation-card-container pointer" (click)="details()">
    <div class="reservation-card">
        <div class="reservation-image-col">
            <img [src]="'./assets/images/icons/file_check_card.png'" [alt]="reservation.eventName" class="reservation-image">
        </div>

        <div class="reservation-content-col">
            <div class="col-header">
                <h3 class="reservation-title">
                    <div *ngIf="canShowCreateOfferButton()" class="status-badge" title="{{ getReservationAdminStatusText() }}">
                        <span class="status-dot blink" [ngClass]="getReservationAdminStatusClass()"></span>
                    </div>
                    <span>
                        <strong>{{ reservation.eventName }}</strong> / {{ reservation.clientName }}
                    </span></h3>
                <div class="right-side">
                    <button *ngIf="canShowCreateOfferButton()" class="create-offer-btn"><img src="./assets/images/icons/suitcase.png" alt="suitcase"><span>Créé une offre</span></button>
                    <div *ngIf="!canShowCreateOfferButton()" class="status-badge">
                        <span class="status-dot" [ngClass]="getReservationAdminStatusClass()"></span>
                        <span class="status-text">{{ getReservationAdminStatusText() }}</span>
                    </div>
                </div>
            </div>

            <div class="reservation-footer">
                <div class="info-col">
                    <div class="data">
                        <img src="./assets/images/icons/user_card_id_gray.png" alt="user_card_id icon"><span>{{ reservation.requiredAgents }}</span>
                    </div>
                    <div class="data">
                        <img src="./assets/images/icons/calendar_calendar_event_gray.png" alt="calendar_calendar_event_gray icon">
                        <span>{{ reservation.startDateTime }} @if(reservation.endDateTime){ <span class="end-time"> - {{reservation.endDateTime}}</span> }</span>
                    </div>
                    <div class="data">
                        <img src="./assets/images/icons/map_pin_gray.png" alt="map_pin_gray icon"><span>{{ formatAddress() }}</span>
                    </div>
                </div>
                <div class="creation-date">
                    {{ reservation.createdAt }}
                </div>
            </div>
        </div>
    </div>
</div>